export default "__VITE_ASSET__CRt_p890__"